import React from "react";
import { Globe2, Landmark, Scale } from "lucide-react";

/** Government & partner reassurance — 3 compliance lines. Reusable site-wide. */
export default function AlignmentBand() {
  const items = [
    { i: <Globe2 size={20}/>,   t: "Aligned with AfCFTA",                d: "Capital moves freely across our launch markets under the African Continental Free Trade Area." },
    { i: <Landmark size={20}/>, t: "Working with national land authorities", d: "Every title is registered at the country's official Deeds / Land Registry." },
    { i: <Scale size={20}/>,    t: "Fully compliant with local property laws", d: "No loopholes. No 'creative' structures. Terms honour the law of each country." },
  ];
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="alignment-band">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Official Alignment</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          Government-aligned. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Never above the law.</span>
        </h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((c) => (
            <div key={c.t} className="mv-card p-6 h-full" data-testid={`alignment-${c.t.split(" ")[0].toLowerCase()}`}>
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center mv-green-text mb-4" style={{ background: "rgba(212,175,55,0.16)" }}>{c.i}</div>
              <div className="font-display text-lg mv-green-text">{c.t}</div>
              <p className="mt-2 text-[14px]" style={{ color: "var(--mv-muted)" }}>{c.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
